/**
 * 1.8.5 (D-1.8.5-4, -5) — the ticket's optional photos: Before (after "Tenant is home — start") and After (with the
 * close-out). Like the Finish sheet: made small on the device (PhotoPicker), and they leave the device only on the
 * press that saves them, each into the ticket's own folder (`…/Before/`, `…/After/`).
 */
import type { PhotoItem } from '@/features/finish/Photos';

export const techPhotoUrl = (appointmentId: string, path: string) => `/api/tech/tickets/${encodeURIComponent(appointmentId)}/photo?path=${encodeURIComponent(path)}`;

/** Sends the photos still on the device; returns every photo's path (those already sent keep theirs). */
export async function uploadTechPhotos(items: PhotoItem[], appointmentId: string, purpose: 'before' | 'after', onProgress?: (n: number, of: number) => void): Promise<string[]> {
  const out: string[] = [];
  const local = items.filter((p) => p.kind === 'local' && !p.path && p.blob);
  let n = 0;
  for (const p of items) {
    if (p.path) {
      out.push(p.path);
      continue;
    }
    if (!p.blob) continue;
    n++;
    onProgress?.(n, local.length);
    const fd = new FormData();
    fd.set('purpose', purpose);
    fd.set('file', p.blob, `${purpose}-${n}.jpg`);
    const res = await fetch(`/api/tech/tickets/${encodeURIComponent(appointmentId)}/photos`, { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } });
    const body = (await res.json().catch(() => null)) as { path?: string; message?: string } | null;
    if (!res.ok || !body?.path) throw new Error(body?.message ?? `Photo ${n} could not be sent (${res.status}).`);
    p.path = body.path;
    p.kind = 'filed';
    out.push(body.path);
  }
  return out;
}
